<template>
    <div class="PricingPlan">
        <section class="container-fluid pb-5" id="pricing">
    <div class="container pricing">
      <div class="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
        <h2>Pricing plan</h2>
        <p class="lead">Writers and stars of Veep have responded incredulously to the news an Australian politician
          required preinstalled stitches way email client, calendar, mapping program.</p>
      </div>

      <div class="container mt-0">
          <div class="row text-center justify-content-center">
              <div class="col-lg col-md-5 col-sm-10 box-shadow kartica m-3">
                <div class="p-5">
                  <h4 class='card-p'>Basic</h4>
                  <h1 class="card-title pricing-card-title">$00</h1>
                  <p class="card-pp">Limited access</p>
                  <ul class="list-unstyled mt-3 mb-4">
                    <li>100 MB Disk Space</li>
                    <li>2 Subdo mains</li>
                    <li>5 Email Accounts</li>
                    <li>No License</li>
                    <li>No Phone & Mail Support</li>
                  </ul>
                  <button type="button" class="btn price-btn">PURCHASE</button>
                </div>
              </div>
    
              <div class="col-lg col-md-5 col-sm-10 box-shadow kartica m-3">
                <div class="p-5">
                  <h4 class='card-p'>Professional</h4>
                  <h1 class="card-title pricing-card-title">$12</h1>
                  <p class="card-pp">Limited access</p>
                  <ul class="list-unstyled mt-3 mb-4">
                    <li>100 MB Disk Space</li>
                    <li>2 Subdo mains</li>
                    <li>5 Email Accounts</li>
                    <li>1 Year License</li>
                    <li>Phone & Mail Support</li>
                  </ul>
                  <button type="button" class="btn price-btn">PURCHASE</button>
                </div>
              </div>
    
              <div class="col-lg col-md-5 col-sm-10 box-shadow kartica m-3">
                <div class="p-5">
                  <h4 class='card-p'>Business</h4>
                  <h1 class="card-title pricing-card-title">$22</h1>
                  <p class="card-pp">Limited access</p>
                  <ul class="list-unstyled mt-3 mb-4">
                    <li>100 MB Disk Space</li>
                    <li>2 Subdo mains</li>
                    <li>5 Email Accounts</li>
                    <li>2 Year License</li>
                    <li>Phone & Mail Support</li>
                  </ul>
                  <button type="button" class="btn price-btn">PURCHASE</button>
                </div>
    
              </div>
    
            </div>

      </div>

    </div>


  </section>
        
    </div>
</template>

<script>
export default {
  name: 'PricingPlan',
  
}

</script>

<style scoped>

@import '../style.css';

#pricing {
    background-color: #F8F6F6;
}
.price-btn {
    border: 1px solid #222847;
    border-radius: 27px;
    background-color: #F8F6F6;
    font-family: 'Poppins';
    font-size: 1.1rem;
}

.kartica {
    border-radius: 20px;
    box-shadow: 0px 2px 7px rgba(34, 31, 31, 0.24);
    border: 2px solid #202646;
    background-color: #F8F6F6;
    transition: all .2s ease-in-out;
}

.kartica:hover {
    border-radius: 0%;
    background-color: #202646;
    color: white;
    transform: scale(1.1);
}

.kartica:hover .card-pp, .kartica:hover .card-p  {
    color: white;
}

.kartica:hover .list-unstyled {
    color: white;
}
.kartica:hover .btn {
    color: #3dc99a;
}

.display-4 {
    font-size: 36px;
    line-height: 36px;
    color: #5d5d5d;
    font-family: "Montserrat";
    font-weight: 500;
    text-align: center;
    padding: 20px;
}

.list-unstyled {
    font-size: 14px;
    line-height: 36px;
    color: #5d5d5d;
    font-family: "Poppins";
    font-weight: 400;
}

.card-p {
    font-family: 'Montserrat';
    font-size: 24px;
    font-weight: 700;
}

.card-pp {
    font-family: 'Poppins';
    font-size: 18px;
    color: #5D5D5D;
    font-weight: bold;
}



</style>
